import { render, staticRenderFns } from "./companies-toolbar.vue?vue&type=template&id=2d479805&"
import script from "./companies-toolbar.ts?vue&type=script&lang=ts&"
export * from "./companies-toolbar.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports